import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize, maxDesktopContentWidth} from '../../shared/theme/helpers';
import {hexWithAlpha} from '../../shared/components/gradientView';
import {Platform} from 'react-native';

const CELL_SPACING = 40;

export const useVolunteersServiceStyles = () => {
  return useStyles(({theme, mediaOnly, isDesktop, deviceSize}) => ({
    root: {
      flexGrow: 1,
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: isDesktop ? 30 : 10,
      paddingBottom: 40,
      backgroundColor: theme.screen.container[deviceSize].backgroundColor,
      ...mediaOnly(DeviceSize.mobile, {paddingHorizontal: 16}, {}),
      ...mediaOnly(DeviceSize.tablet, {paddingHorizontal: 35}, {}),
      ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 60}, {}),
    },
    content: {
      width: '100%',
      maxWidth: maxDesktopContentWidth,
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    title: {
      marginBottom: 30,
      marginTop: 38,
    },
    descriptionTitle: mediaOnly(DeviceSize.desktop, {marginTop: 10, ...theme.fonts.h5}, theme.fonts.bodySmall),
    descriptionBody: {
      marginTop: isDesktop ? 32 : 24,
      marginBottom: isDesktop ? 56 : 30,
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight),
    },
    rightImage: {
      width: 820,
      marginTop: 0,
    },
    toEventsButton: {
      maxWidth: 360,
      width: '100%',
      textAlign: 'center',
      marginHorizontal: 0,
    },
    link: {
      transform: [{translateY: Platform.OS === 'web' ? 0 : Platform.OS === 'ios' ? 3 : 6}],
      color: theme.color.primaryColor,
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight),
    },
  }));
};

export const GetDesktopTableStyles = () => {
  return useStyles(({theme}) => ({
    container: {
      width: 'auto',
      maxWidth: 900,
    },
    noData: {
      paddingVertical: 24,
      color: theme.color.grayMenu,
    },
    headCell: {
      ...theme.fonts.body,
      color: theme.color.grayMenu,
      marginRight: CELL_SPACING,
    },
    cell: {
      marginRight: CELL_SPACING,
    },
    colDescription: {
      flexBasis: 417,
      maxWidth: 417,
    },
    colAmount: {
      flexBasis: 203,
      maxWidth: 203,
      textAlign: 'end',
    },
    colDate: {
      flexBasis: 114,
      flexGrow: 1,
    },
  }));
};

export const GetMobileTableStyles = () => {
  return useStyles(({theme}) => ({
    container: {},
    noData: {
      paddingVertical: 24,
      color: theme.color.grayMenu,
    },
    item: {
      borderWidth: 1,
      borderColor: theme.color.primaryColor,
      borderRadius: 14,
      overflow: 'hidden',
      marginBottom: 16,
    },
    itemHead: {
      paddingHorizontal: 20,
      paddingVertical: 8,
    },
    itemBody: {
      paddingHorizontal: 20,
      paddingVertical: 8,
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: hexWithAlpha(theme.color.primaryColor, 0.15),
    },
    itemBodyDate: {
      color: theme.color.primaryBlackColor,
    },
  }));
};
